export const exclusions = [
  'the-cost-of-buying-a-house-aTnH73d3llji',
  'remortgaging-how-to-save-thousands-on-your-mortgage-aMohE3o6d7ge',
  'remortgaging-to-release-equity-and-cash-from-your-home-aYfw50P4PAts',
  'finding-the-best-places-to-live-aLb820B94N7C',
  'mortgage-valuations-explained-atl9w6F5jdx8',
  'how-much-is-your-house-worth-ayipK9s4Gzpq',
  'how-to-sell-your-house-anypC0y71t2m',
  'renting-a-home-the-first-steps-a8Q9F1l0x1Pr',
  'rental-property-checklist-aHpnm2r3Sicn',
  'what-to-do-if-you-cant-pay-your-rent-a1plz2a9VrOm',
  'rental-property-maintenance-and-repairs-aXhBi6A5qzSI',
  'tenancy-deposit-schemes-aDWsg9f1cevM',
  'tenancy-agreements-aocY47g5x8wJ',
]
export const baseUrl = 'https://www.landc.co.uk/destination/partners/which-general3'
export const control = '?utm_source=which&utm_medium=referral&utm_campaign=comparemortgages'
export const variant = '?utm_source=which&utm_medium=referral&utm_campaign=getaquote'

export const isArticleInTest = (pageParams, isTestActive) => {
  if (pageParams?.subVerticalSlug && pageParams?.articleSlug) {
    const isMortgages = pageParams.subVerticalSlug === 'mortgages-and-property'
    const isExcluded = exclusions.includes(pageParams.articleSlug)
    return isTestActive && isMortgages && !isExcluded
  } else {
    return false
  }
}

export const addTrackingCode = (url, articleInCtaTest) => {
  if (url === baseUrl) {
    return articleInCtaTest ? baseUrl + variant : baseUrl + control
  } else {
    return url
  }
}
